import { useState, useEffect } from "react";
import { AuthContext } from '../context/AuthContext';
import { isAuthenticated } from "../common/api/auth";

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());

  useEffect(() => {
    setIsLoggedIn(isAuthenticated());
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
}
